import { getCookie } from "../jwt/_helpers/cookie";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;
const SESSION_STORAGE_KEY = "audit_session_id";

const generateId = () => {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `audit_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

export const getOrCreateAuditSessionId = () => {
  try {
    const existing = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (existing) return existing;
    const generated = `sess_${generateId()}`;
    sessionStorage.setItem(SESSION_STORAGE_KEY, generated);
    return generated;
  } catch (error) {
    return `sess_${generateId()}`;
  }
};

export const sendAuditEvent = async ({
  token,
  eventType,
  route,
  entityIds = [],
  metadata = {},
}) => {
  const authToken = token || getCookie("token");
  if (!authToken || !eventType) return false;

  try {
    const payload = {
      event_type: eventType,
      route: route || (typeof window !== "undefined" ? window.location.pathname : null),
      session_id: getOrCreateAuditSessionId(),
      log_id: generateId(),
      entity_ids: entityIds,
      recorded_at: new Date().toISOString(),
      metadata: {
        source: "web",
        tenant: "ml",
        ...metadata,
      },
    };

    const response = await fetch(`${API_URL}audit-logs/`, {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${authToken}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    return response.ok;
  } catch (error) {
    console.error("Failed to send audit event", error);
    return false;
  }
};

export const fetchAllStatementIdsForInvoiceCreation = async ({
  token,
  search = "",
  ordering = "-created",
  pageSize = 200,
}) => {
  const authToken = token || getCookie("token");
  if (!authToken) return [];

  const statementIds = [];
  let page = 1;

  try {
    while (true) {
      const response = await fetch(
        `${API_URL}statements/?ordering=${encodeURIComponent(ordering)}&page=${page}&page_size=${pageSize}&search=${encodeURIComponent(search)}&status=0&invoice_generated=false`,
        {
          method: "GET",
          mode: "cors",
          headers: {
            Authorization: `Bearer ${authToken}`,
            "x-api-key": X_API_KEY,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) break;
      const data = await response.json();
      const results = Array.isArray(data?.results) ? data.results : [];

      results.forEach(statement => {
        if (statement?.id !== undefined && statement?.id !== null) {
          statementIds.push(statement.id);
        }
      });

      if (!data?.next || results.length === 0) break;
      page += 1;
    }
  } catch (error) {
    console.error("Failed to fetch statement ids for invoice creation audit", error);
  }

  return statementIds;
};
